import Vue from 'vue'

const state = {
  quickSelections: [],
  // 筛选开关
  filterPopupShow: false,
  newQuickSelections: {},
  copyNewQuickSelections: {}
}

const mutations = {
  // 修改 quickSelections
  SET_QUICK_SELECTIONS: (state, selections) => {
    state.quickSelections = selections
  },

  // 修改 quickSelections 单个数据
  MODIFY_QUICK_SELECTIONS_ONE: (state, payload) => {
    const { index, item } = payload
    Vue.set(state.quickSelections, index, item)
  },

  SET_FILTER_POPUP_SHOW: (state, payload) => {
    state.filterPopupShow = payload
  },

  // 新筛选项数据 newQuickSelections
  SET_NEW_QUICK_SELECTIONS: (state, selections) => {
    state.newQuickSelections = selections
  },

  // 重置时使用的默认数据 copyNewQuickSelections
  SET_COPY_NEW_QUICK_SELECTIONS: (state, selections) => {
    state.copyNewQuickSelections = selections
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
